import React, { useState, useEffect } from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { dataFetch } from '../api';
import { TableSkeleton } from '../components/common/Skeleton';

const AdminModeration = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPublicTemplates();
  }, []);

  const loadPublicTemplates = async () => {
    setLoading(true);
    // Moderation reads all public templates. No user_id filter needed as shared_read policy allows it.
    // ncb sorting uses 'sort' parameter.
    const res = await dataFetch(`read/templates?is_public=true&sort=created_at&order=desc`);
    setTemplates(res?.data || []);
    setLoading(false);
  };

  const togglePublicStatus = async (id, currentStatus) => {
    const res = await dataFetch(`update/templates/${id}`, {
      method: 'PUT',
      body: JSON.stringify({ is_public: !currentStatus })
    });

    if (res?.status === 'success') {
      setTemplates(prev => prev.map(t => t.id === id ? { ...t, is_public: !currentStatus } : t));
    }
  };

  if (loading) return <div className="max-w-7xl mx-auto px-4 py-8"><TableSkeleton /></div>;

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="mb-8 font-display text-3xl font-bold text-navy tracking-tight">Moderação de modelos</h1>

      {templates.length === 0 ? (
        <div className="bg-paper rounded-card border border-line shadow-card flex flex-col items-center justify-center py-20 text-center px-4">
          <p className="text-sm font-semibold text-ink mb-1">Nenhum modelo público no momento</p>
          <p className="text-sm text-muted max-w-xs">Modelos publicados pela comunidade aparecerão aqui para moderação.</p>
        </div>
      ) : (
        <div className="bg-paper rounded-card border border-line overflow-hidden shadow-card">
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead className="bg-paper-alt/80 border-b border-line text-[10px] font-semibold text-muted uppercase tracking-widest">
                <tr>
                  <th className="px-6 py-4">Template</th>
                  <th className="px-6 py-4">Autor</th>
                  <th className="px-6 py-4">Categoria</th>
                  <th className="px-6 py-4">Uso</th>
                  <th className="px-6 py-4 text-right">Ações</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-line">
                {templates.map(template => (
                  <tr key={template.id} className="hover:bg-paper-alt/50 transition-colors">
                    <td className="px-6 py-4">
                      <p className="font-semibold text-ink">{template.name}</p>
                      <p className="text-xs text-muted line-clamp-1">{template.description}</p>
                    </td>
                    <td className="px-6 py-4 text-sm text-muted">
                      {template.author_name || 'Profissional'}
                    </td>
                    <td className="px-6 py-4">
                      <span className="px-2.5 py-1 bg-paper-alt text-navy border border-line rounded-md text-[10px] font-semibold uppercase tracking-wide">
                        {template.category}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-ink tabular-nums">
                      {template.usage_count} importações
                    </td>
                    <td className="px-6 py-4 text-right space-x-1">
                      <button
                        onClick={() => togglePublicStatus(template.id, template.is_public)}
                        className={`p-2.5 min-h-[44px] min-w-[44px] rounded-card transition-colors ${template.is_public ? 'text-danger hover:bg-danger-tint' : 'text-selo hover:bg-selo-tint'}`}
                        title={template.is_public ? 'Despublicar da comunidade' : 'Aprovar na comunidade'}
                        aria-label={template.is_public ? `Despublicar ${template.name}` : `Aprovar ${template.name}`}
                      >
                        {template.is_public
                          ? <XCircle className="w-5 h-5" aria-hidden="true" />
                          : <CheckCircle2 className="w-5 h-5" aria-hidden="true" />}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminModeration;
